export const pathname = `/mobility/browse`;

export enum Brand {
    DBA = "DBA",
    FINN = "FINN",
    BLOCKET = "BLOCKET",
}

export enum Locale {
    NB = "nb",
    DA = "da",
    SV = "sv",
    EN = "en",
}

export enum Subvertical {
    Car = "car",
    Mc = "mc",
    B2B = "b2b",
    Boat = "boat",
}

export enum Env {
    LOCAL = "local",
    DEV = "dev",
    PROD = "prod",
}

export enum Namespace {
    MOBILITY = "mobility",
    RECOMMERCE = "recommerce",
}
